var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExclamation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 22,
    height: 22,
    rx: 11,
    fill: "#FF4728"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 15.6255C12.375 16.3848 11.7594 17.0005 11 17.0005C10.2406 17.0005 9.625 16.3848 9.625 15.6255C9.625 14.8661 10.2406 14.2505 11 14.2505C11.7594 14.2505 12.375 14.8661 12.375 15.6255Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1062 6.45527C10.1062 5.96167 10.5064 5.56152 11 5.56152C11.4936 5.56152 11.8937 5.96167 11.8937 6.45527V11.9817C11.8937 12.4753 11.4936 12.8755 11 12.8755C10.5064 12.8755 10.1062 12.4753 10.1062 11.9817V6.45527Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.7c0cdeea0c45d13357e4711ce0f2f984.svg";
export { ForwardRef as ReactComponent };